/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetCciDailyUbiResponse } from '../models/ApiResponseGetCciDailyUbiResponse';
import type { ApiResponseGetCciHourlyUbiResponse } from '../models/ApiResponseGetCciHourlyUbiResponse';
import type { ApiResponseGetCciMonthlyUbiResponse } from '../models/ApiResponseGetCciMonthlyUbiResponse';
import type { ApiResponseGetCciUbiPredctionResponse } from '../models/ApiResponseGetCciUbiPredctionResponse';
import type { ApiResponseGetCciUbiResponse } from '../models/ApiResponseGetCciUbiResponse';
import type { ApiResponseGetCciUbiSummaryResponse } from '../models/ApiResponseGetCciUbiSummaryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UbiControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 안전운전점수 summary
   * @returns ApiResponseGetCciUbiSummaryResponse OK
   * @throws ApiError
   */
  public getUbiSummary2({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciUbiSummaryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/summary/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 summary
   * @returns ApiResponseGetCciUbiSummaryResponse OK
   * @throws ApiError
   */
  public getUbiSummary3({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciUbiSummaryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/summary',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 예측결과
   * @returns ApiResponseGetCciUbiPredctionResponse OK
   * @throws ApiError
   */
  public getUbiPrediction1({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciUbiPredctionResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/prediction',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 월별리포트
   * @returns ApiResponseGetCciMonthlyUbiResponse OK
   * @throws ApiError
   */
  public getMonthlyUbi2({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciMonthlyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/monthly',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 월별리포트
   * @returns ApiResponseGetCciMonthlyUbiResponse OK
   * @throws ApiError
   */
  public getMonthlyUbi3({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciMonthlyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/monthly/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 시간대별 리포트
   * @returns ApiResponseGetCciHourlyUbiResponse OK
   * @throws ApiError
   */
  public getHourlyUbi2({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciHourlyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/hourly/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 시간대별 리포트
   * @returns ApiResponseGetCciHourlyUbiResponse OK
   * @throws ApiError
   */
  public getHourlyUbi3({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciHourlyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/hourly',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 일별리포트
   * @returns ApiResponseGetCciDailyUbiResponse OK
   * @throws ApiError
   */
  public getDailyUbi2({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciDailyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/daily',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 일별리포트
   * @returns ApiResponseGetCciDailyUbiResponse OK
   * @throws ApiError
   */
  public getDailyUbi3({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciDailyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/daily/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 상세
   * @returns ApiResponseGetCciUbiResponse OK
   * @throws ApiError
   */
  public getUbi4({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 상세
   * @returns ApiResponseGetCciUbiResponse OK
   * @throws ApiError
   */
  public getUbi5({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetCciUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cci/ubi/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
}
